import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { testopsProject } from './launches';

const TESTOPS_FLAG = 'allure-testops';

/**
 * The «Автотесты» card, on any entity with a numeric
 * `qameta.io/testops-project-id`. Nothing writes that annotation yet — it
 * belongs in cartographer's catalog-etl, from a field of the service's record.
 * Behind a feature flag, per user in Settings → Feature Flags: with it off the
 * card is gone, and the backend's route is simply never called.
 */
const EntityTestOpsCard = EntityCardBlueprint.make({
  name: 'allure-testops',
  if: { featureFlags: { $contains: TESTOPS_FLAG } },
  params: {
    filter: entity => testopsProject(entity) !== undefined,
    loader: () => import('./TestOpsCard').then(m => <m.TestOpsCard />),
  },
});

export const testopsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [EntityTestOpsCard],
  featureFlags: [
    {
      name: TESTOPS_FLAG,
      description: 'Show the Allure TestOps card («Автотесты») on entities',
    },
  ],
});
